import { TextField } from "@mui/material"
import { TestData } from "graphql/types"
import { useEffect } from "react"

type TakeNoteBoxProps = {
  data: TestData
  setData: (data: TestData) => void
  name: string
  setName?: boolean
}

export const TakeNoteBox = (props: TakeNoteBoxProps) => {
  const { data, setData, name, setName = true } = props

  useEffect(() => {
    if (name) setData({ ...data, name: name })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [name])

  return (
    <>
      {setName && (
        <TextField
          sx={{ mt: 1 }}
          size="small"
          label="Titel"
          value={data.name}
          variant="outlined"
          fullWidth
          onChange={(e) => setData({ ...data, name: e.target.value })}
        />
      )}
      <TextField
        size="small"
        label="Notiz / Anmerkung / Beschreibung"
        value={data.description}
        variant="outlined"
        fullWidth
        multiline
        onChange={(e) => setData({ ...data, description: e.target.value })}
      />
    </>
  )
}
